import React, {useEffect} from "react";
import styles from "./SearchResults.module.scss";

import { standardTheme, megaTheme, gigaTheme } from "../theme";
import { FlexRow } from "../..";

const SearchResults = ( { resultsList, handleClick } ) =>
{
    return (
        <ul className={styles.root}>
            {
                resultsList.map( 
                    (chip) => 
                    <li 
                        className={styles.record}
                        style={ chip.categoryId === 1 ? standardTheme : ( chip.categoryId === 2 ? megaTheme : gigaTheme ) }
                        onClick={ () => handleClick(chip.gameId) }
                        key={chip.gameId}
                        id={chip.gameId}
                    >
                        <FlexRow id={chip.id} style={ { margin: '0 0.25rem', justifyContent: 'space-between', minWidth: '3rem'} } >
                            <span name={chip.libId}>{chip.libId}</span>
                            <img src={chip.iconUrl}></img>
                        </FlexRow>

                        <span className={styles.name}>{chip.name}</span>
                    </li>
                )
            }
        </ul>
    );
}

export default SearchResults;